const _ = require('lodash')
import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.fixed = true
    this.prevScrollPosition = window.pageYOffset
    this.element.style.transition = 'top 0.3s'
  }

  adjust = _.throttle(() => {
    if(this.scrollingUp()) {
      if(!this.fixed){
        document.body.style.paddingTop = `${this.height()}px`
        this.element.style.top = '0'
        this.fixed = true
      }
    } else {
      if(this.fixed){
        document.body.style.paddingTop = 0
        this.element.style.top = `-${this.height()}px`
        this.fixed = false
      }
    }
    this.prevScrollPosition = window.pageYOffset
  }, 200)

  height() {
    return this.element.getBoundingClientRect().height
  }

  scrollingUp() {
    return window.pageYOffset < this.prevScrollPosition
  }
}
